"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTxAmounts = exports.getTxCanonicalMsgs = void 0;
var collector_1 = require("./collector");
var utility_1 = require("./utility");
var getTxCanonicalMsgs = function (txInfo, logMatcher) {
    var _a;
    try {
        var matched = (_a = txInfo === null || txInfo === void 0 ? void 0 : txInfo.logs) === null || _a === void 0 ? void 0 : _a.map(function (log) {
            var matchLog = logMatcher(log.events);
            var matchedPerLog = matchLog === null || matchLog === void 0 ? void 0 : matchLog.flat().filter(Boolean).map(function (data) { return (__assign(__assign({}, data), { timestamp: txInfo.timestamp })); });
            return matchedPerLog;
        });
        var logMatched = matched === null || matched === void 0 ? void 0 : matched.map(function (match) { return collector_1.collector(match); });
        if (logMatched === undefined ||
            (logMatched && logMatched.flat().length <= 0)) {
            // not matched rulesets or transaction failed or log is null (old network)
            var defaultCanonicalMsg = utility_1.defaultAction(txInfo.tx);
            return [defaultCanonicalMsg];
        }
        return logMatched;
    }
    catch (e) {
        var fragment = {
            type: "Unknown",
            attributes: [],
        };
        var transformed = {
            msgType: "unknown/terra",
            canonicalMsg: ["Unknown tx"],
            payload: fragment,
        };
        return [[{ fragment: fragment, match: [], transformed: transformed }]];
    }
};
exports.getTxCanonicalMsgs = getTxCanonicalMsgs;
var getTxAmounts = function (data, logMatcher, address) {
    try {
        var tx = JSON.parse(data);
        if (tx.logs) {
            var msgTypes_1 = tx.tx.body.messages;
            var timestamp_1 = tx.timestamp, txhash_1 = tx.txhash;
            var matched = tx.logs.map(function (log, index) {
                var matchLog = logMatcher(log.events);
                var matchedPerLog = matchLog === null || matchLog === void 0 ? void 0 : matchLog.flat().filter(Boolean).map(function (data) {
                    var msgType = msgTypes_1[index]["@type"].split("/")[1];
                    return utility_1.formatLogs(data, msgType, address, timestamp_1, txhash_1);
                });
                return matchedPerLog;
            });
            return matched.flat().length > 0 ? matched : undefined;
        }
    }
    catch (_a) {
        return undefined;
    }
};
exports.getTxAmounts = getTxAmounts;
//# sourceMappingURL=format.js.map